<template>
  <Modal v-model="choiceBillModal" width="1200" footer-hide>
    <p slot="header" class="text-center">添加合同账单</p>
    <Row :gutter="8" class="m-b-5">
      <i-col span="8">
        <Button type="primary" size="small" class="m-r-20" :disabled="selectedIds.length===0" @click="handleBatchSubmit">批量添加至收款单</Button>
        <Checkbox v-model="checkAllBill" :disabled="tableLoading" @on-change="hanldeCheckAllBill">一键全选所有账单</Checkbox>
      </i-col>
      <i-col span="16" class="text-right">
        <DatePicker type="date" v-model="query.startDate" @on-change="handleSearch" size="small" placeholder="选择账单开始日期" clearable style="width: 200px"></DatePicker>
        <DatePicker type="date" v-model="query.endDate" @on-change="handleSearch" size="small" class="m-l-10" placeholder="选择账单结束日期" clearable style="width: 200px"></DatePicker>

        <RadioGroup v-model="selectedGroup" class="m-l-20" @on-change="handleSearch" type="button" size="small" button-style="solid">
            <Radio v-for="(item,index) in billGroupArray" :key="index" :label="item"></Radio>
        </RadioGroup>
      </i-col>
    </Row>
    <Table
      size="small"
      ref="selectionTable"
      :columns="tableColumns"
      :data="tableData"
      :loading="tableLoading"
      @on-selection-change="selectionChange"
      stripe
    ></Table>
    <div class="paging_style">
        <Page size="small" show-total show-elevator :current="query.pageNumber" :page-size="query.pageSize" :total="total" @on-change="handlePageNumberChange"></Page>
    </div>

    <Spin fix size="large" v-if="spinShow">
        <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
        <div>提交中...</div>
    </Spin>
  </Modal>
</template>

<script>
import { toMoney } from '@/utils/wnumb_own'
import { listDetailByContract, addDebtDetail } from '@/api/invest/debt'

export default {
  data () {
    return {
      choiceBillModal: false,
      spinShow: false,

      checkAllBill: false,

      selectedIds: [],
      tempSelectedIds: [],

      billGroupArray: [],
      selectedGroup: null,

      query: {
        contractId: null,
        status: 1, // 默认值取1， 状态(1:已对账;2:结算中;3:已结算)
        pageNumber: 1,
        pageSize: 15,
        startDate: '',
        endDate: ''
      },

      tableLoading: false,
      total: 0,
      baseTableData: [],
      showTableData: [],
      tableData: [],
      tableColumns: [
        { type: 'selection', width: 60, align: 'center' },
        { title: '标的物名称', key: 'objectName' },
        { title: '所属线路', key: 'assetName' },
        { title: '所在站点', key: 'stationName' },
        { title: '开始日期', key: 'startDate' },
        { title: '结束日期', key: 'endDate' },
        { title: '费用类型', key: 'feeTypeName' },
        {
          title: '账单金额',
          key: 'amount',
          render: (h, params) => {
            return h('strong', {
              attrs: {
                style: 'color:#44bd32'
              }
            },
            toMoney(params.row.amount))
          }
        }
      ]
    }
  },
  methods: {
    showModal (contractId) {
      this.choiceBillModal = true
      this.query.contractId = contractId
      this.initPageData()
    },
    initPageData () {
      this.tableLoading = true
      // 载入账单信息
      listDetailByContract(this.query).then(res => {
        this.baseTableData = res
        this.tableLoading = false

        const group = ['全部']
        res.forEach(element => {
          if (!group.includes(element.feeTypeName)) {
            group.push(element.feeTypeName)
          }
        })
        this.billGroupArray = group
        this.selectedGroup = group[0]

        this.handleSearch()
      })
    },
    handleSearch () {
      if (this.selectedGroup === '全部') {
        this.showTableData = this.baseTableData
      } else {
        this.showTableData = this.baseTableData.filter(x => x.feeTypeName === this.selectedGroup)
      }

      if (this.query.startDate) {
        this.showTableData = this.showTableData.filter(x => new Date(x.startDate) > this.query.startDate)
      }
      if (this.query.endDate) {
        let formatEndDate = new Date(this.query.endDate)
        formatEndDate = formatEndDate.setDate(formatEndDate.getDate() + 1)

        this.showTableData = this.showTableData.filter(x => new Date(x.endDate) < formatEndDate)
      }

      this.total = this.showTableData.length
      this.handlePageNumberChange(1)
    },
    handlePageNumberChange (page) {
      this.query.pageNumber = page
      const startRow = (this.query.pageNumber - 1) * this.query.pageSize
      const getRows = startRow + this.query.pageSize
      const pageData = []

      for (let index = startRow; index < getRows; index++) {
        if (index < this.showTableData.length) {
          pageData.push(this.showTableData[index])
        }
      }

      // 需要自动勾选被选中的项
      pageData.forEach(item => {
        item._checked = this.selectedIds.includes(item.id)
      })

      this.tableData = pageData
    },
    selectionChange (selections) {
      const curSelection = selections.map(x => x.id)
      this.tableData.forEach(item => {
        // 当前被勾选
        if (curSelection.includes(item.id)) {
          if (!this.selectedIds.includes(item.id)) {
            this.selectedIds.push(item.id)
          }
        } else {
          // 当前未被勾选， 且存在勾选清单，那么移除
          if (this.selectedIds.includes(item.id)) {
            const index = this.selectedIds.findIndex(x => x === item.id)
            this.selectedIds.splice(index, 1)
          }
        }
      })
    },
    hanldeCheckAllBill (val) {
      if (val) { // 全部选中
        this.selectedIds = this.showTableData.map(x => x.id)
        // 需要自动勾选被选中的项
        this.showTableData.forEach(item => {
          item._checked = true
        })
      } else {
        this.selectedIds = []
        // 需要自动取消被选中的项
        this.showTableData.forEach(item => {
          item._checked = false
        })
      }
      this.$refs.selectionTable.selectAll(val)
    },
    handleBatchSubmit () {
      const addBean = {
        debtId: this.receiptId,
        detailIds: this.selectedIds.join(',')
      }

      this.spinShow = true
      addDebtDetail(addBean).then(res => {
        if (res && res.success) {
          this.$emit('on-success')
          this.$Notice.success({ desc: '操作成功' })
        }
      }).finally(() => {
        this.spinShow = false
        this.choiceBillModal = false
      })
    }
  },
  computed: {
    receiptId () {
      return this.$store.state.receipts.receiptId
    }
  }
}
</script>
